<!-- New create/edit button -->
<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <!-- edit button -->
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- Render Content -->
  <div
    *ngIf="content"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <!-- Banner Display -->
    <ng-container [ngSwitch]="componentLabel">
      <!-- Standard Banner Component-->
      <ng-container *ngSwitchCase="'Banner'">
        <ng-container *ngTemplateOutlet="standardBanner"></ng-container>
      </ng-container>

      <!-- 50/50 Banner Component -->
      <ng-container *ngSwitchCase="'Banner 50/50'">
        <eds-banner-impact-expanded
          [bannerTheme]="theme || 'primary'"
          [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
          [preTitle]="content.category"
          [title]="content.title"
          [subTitle]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [hasLogo]="content.logoLink ? true : false"
          [logoLink]="content.logoLink"
          [simLogoSrc]="content.logoLink"
          [simLogoAltText]="content.altlogoText"
          [altlogoText]="content.altlogoText"
          [wide]="true"
          [caveatContent]="disclaimerCaveat"
          [summary]="content.summary"
          [isCondensed]="isCondensed"
          [isResponsiveImageVersion]="isResponsiveImageVersion"
          [mobileSrcSet]="content.mobile"
          [tabletSrcSet]="content.smallTablet"
          [largeTabletSrcSet]="content.largeTablet"
          [smallDesktopSrcSet]="content.smallDesktop"
          [desktopSrcSet]="content.regularDesktop"
          [introTitle]="content?.introduction"
          [size]="titleSize !== 'default' ? 'xxl' : 'h1'"
          [navCards]="links"
        >
          <div>
            <!-- CTA Buttons -->
            <ng-container *ngIf="content.button?.length">
              <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
            </ng-container>

            <!-- Important information link -->
            <ng-container *ngIf="content.importantinformationlink?.displayText">
              <div edsPadding edsPaddingTop="lg">
                <eds-link-item
                  [theme]="'light'"
                  [href]="content.importantinformationlink?.url"
                  [title]="content.importantinformationlink?.displayText"
                  [isNewWindow]="content.importantinformationlink?.target"
                  [isExternal]="content.importantinformationlink?.external"
                  [externalSuffix]="
                    content.importantinformationlink?.externalSuffix
                  "
                  (click)="
                    processLink($event, content.importantinformationlink)
                  "
                  [analyticsNoEvent]="true"
                  [signInRequired]="signInRequired | ftIsSignInRequired | async"
                  [hideLockIcon]="hideLockIcon"
                  [signInTooltip]="'common.locked-link-tooltip' | translate"
                ></eds-link-item>
              </div>
            </ng-container>
          </div>
        </eds-banner-impact-expanded>
      </ng-container>

      <!-- Impact Banner Component-->
      <ng-container *ngSwitchCase="'Banner Impact'">
        <eds-banner-impact-vi
          *ngIf="skin !== 'V2'"
          [title]="content.title"
          [preTitle]="content.category"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired | ftIsSignInRequired | async"
          [hideLockIcon]="hideLockIcon"
          [signInTooltip]="'common.locked-link-tooltip' | translate"
          [widenParams]="buttonWidenParams"
          [hasViLogo]="!!content.logoLink"
          [logoLink]="content?.logoLink"
          [isResponsiveImageVersion]="isResponsiveImageVersion"
          [mobileSrcSet]="content.mobile"
          [tabletSrcSet]="content.smallTablet"
          [largeTabletSrcSet]="content.largeTablet"
          [smallDesktopSrcSet]="content.smallDesktop"
          [desktopSrcSet]="content.regularDesktop"
          [navCards]="links"
        >
          <!-- CTA Buttons -->
          <ng-container *ngIf="content.button?.length">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </ng-container>
          <!-- / CTA Buttons -->
        </eds-banner-impact-vi>

        <eds-banner-impact-vi-2
          *ngIf="skin === 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired | ftIsSignInRequired | async"
          [hideLockIcon]="hideLockIcon"
          [signInTooltip]="'common.locked-link-tooltip' | translate"
          [widenParams]="buttonWidenParams"
        ></eds-banner-impact-vi-2>
      </ng-container>

      <!-- With Nav Component -->
      <eds-banner-nav
        *ngSwitchCase="'Banner (with nav)'"
        [theme]="theme ? theme : 'primary'"
        [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
        [preTitle]="content.category"
        [title]="content.title"
        [subTitle]="content.subTitle"
        [caveatContent]="disclaimerCaveat"
        [navCards]=""
      >
        <!-- CTA Buttons -->
        <ng-container *ngIf="content.button">
          <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
        </ng-container>
      </eds-banner-nav>
      <!-- / With nav -->

      <!-- Impact Banner VI Component -->
      <ng-container *ngSwitchCase="'Banner Impact VI'">
        <eds-banner-impact-vi
          *ngIf="skin !== 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired | ftIsSignInRequired | async"
          [hideLockIcon]="hideLockIcon"
          [signInTooltip]="'common.locked-link-tooltip' | translate"
          [widenParams]="buttonWidenParams"
        ></eds-banner-impact-vi>
        <eds-banner-impact-vi-2
          *ngIf="skin === 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired | ftIsSignInRequired | async"
          [hideLockIcon]="hideLockIcon"
          [signInTooltip]="'common.locked-link-tooltip' | translate"
          [widenParams]="buttonWidenParams"
        ></eds-banner-impact-vi-2>
      </ng-container>

      <!-- Standard Banner Image/Gradient -->
      <ng-container *ngSwitchCase="'Standard Banner Image/Gradient'">
        <eds-banner-standard-gradient
          *ngIf="gradient === 'Gradient'"
          [basicLayout]="gradientLayout"
          [title]="content.title"
          [summary]="content.summary"
          [hasLogo]="true"
          [logoSrc]="content.logoLink"
          [logoAltText]="content.altlogoText"
          [hasBannerButton]="true"
          [caveatContent]="disclaimerCaveat"
        >
          <ng-container *ngIf="content.button?.length">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </ng-container>
        </eds-banner-standard-gradient>
        <eds-banner-standard-image
          *ngIf="gradient === 'Image'"
          [basicLayout]="gradientLayout"
          [imageSrc]="content.imageSrc"
          [title]="content.title"
          [summary]="content.summary"
          [hasLogo]="true"
          [logoSrc]="content.logoLink"
          [logoAltText]="content.altlogoText"
          [hasBannerButton]="true"
          [caveatContent]="disclaimerCaveat"
        >
          <ng-container *ngIf="content.button?.length">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </ng-container>
        </eds-banner-standard-image>
      </ng-container>

      <!-- Video Banner Component -->
      <ng-container *ngSwitchCase="'Banner Video'">
        <eds-banner-video
          [title]="content.title"
          [theme]="theme ? theme : 'primary'"
          [summary]="content.summary"
          [video]="video"
          [thematic]="thematic"
          [thematicB]="thematicB"
          [isHideTitle]="isHideTitle"
          [hasSimsLogo]="showSimLogo"
          [simsImgSrc]="content.logoLink"
          [simsAltText]="content.altlogoText"
          [caveatContent]="disclaimerCaveat"
          [preTitle]="content?.category"
          [navCards]="links"
        >
          <div>
            <!-- CTA Buttons -->
            <ng-container *ngIf="content.button?.length">
              <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
            </ng-container>
            <!-- / CTA Buttons -->

            <!-- Important information link -->
            <ng-container *ngIf="content.importantinformationlink?.displayText">
              <div edsPadding edsPaddingTop="lg">
                <eds-link-item
                  [theme]="'light'"
                  [href]="content.importantinformationlink?.url"
                  [title]="content.importantinformationlink?.displayText"
                  [isNewWindow]="content.importantinformationlink?.target"
                  [isExternal]="content.importantinformationlink?.external"
                  [externalSuffix]="
                    content.importantinformationlink?.externalSuffix
                  "
                  (click)="
                    processLink($event, content.importantinformationlink)
                  "
                  [analyticsNoEvent]="true"
                  [signInRequired]="signInRequired | ftIsSignInRequired | async"
                  [hideLockIcon]="hideLockIcon"
                  [signInTooltip]="'common.locked-link-tooltip' | translate"
                ></eds-link-item>
              </div>
            </ng-container>
            <!-- / Important information link -->
          </div>
        </eds-banner-video>
      </ng-container>

      <!-- Standard Default -->
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="standardBanner"></ng-container>
      </ng-container>
    </ng-container>

    <!-- Standard Template-->
    <ng-template #standardBanner>
      <ng-container *ngIf="content.imageSrc; else StandardOrColorblockBanner">
        <eds-banner-standard
          [theme]="theme ? theme : 'primary'"
          [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
          [preTitle]="content.category"
          [title]="content.title"
          [titleLevel]="1"
          [titleSize]="'h1'"
          [subTitle]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [logoLink]="content.logoLink"
          [altlogoText]="content.altlogoText"
          [wide]="true"
          [videoAccountId]="content.video?.accountId"
          [videoId]="content.video?.videoId"
          [videoPlayerId]="content.video?.videoPlayerId"
          [videoTranscript]="content.video?.videoTranscript"
          [caveatContent]="disclaimerCaveat"
          [hasRibbon]="ribbon"
          [sessionMask]="enableSessionMask"
        >
          <div>
            <!-- CTA Buttons -->
            <ng-container *ngIf="content.button?.length">
              <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
            </ng-container>
            <!-- / CTA Buttons -->

            <!-- Important information link -->
            <ng-container *ngIf="content.importantinformationlink?.displayText">
              <div edsPadding edsPaddingTop="lg">
                <eds-link-item
                  [theme]="'light'"
                  [href]="content.importantinformationlink?.url"
                  [title]="content.importantinformationlink?.displayText"
                  [isNewWindow]="content.importantinformationlink?.target"
                  [isExternal]="content.importantinformationlink?.external"
                  [externalSuffix]="
                    content.importantinformationlink?.externalSuffix
                  "
                  (click)="
                    processLink($event, content.importantinformationlink)
                  "
                  [analyticsNoEvent]="true"
                  [signInRequired]="signInRequired | ftIsSignInRequired | async"
                  [hideLockIcon]="hideLockIcon"
                  [signInTooltip]="'common.locked-link-tooltip' | translate"
                ></eds-link-item>
              </div>
            </ng-container>
            <!-- / Important information link -->
          </div>
        </eds-banner-standard>
      </ng-container>

      <ng-template #StandardOrColorblockBanner>
        <ng-container
          *ngIf="content?.logoLink || content?.video; else EDSColorblockBanner"
        >
          <eds-banner-standard
            [theme]="theme || 'primary'"
            [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
            [preTitle]="content.category"
            [title]="content.title"
            [titleLevel]="1"
            [titleSize]="'h1'"
            [subTitle]="content.subTitle"
            [imageSrc]="content.imageSrc"
            [logoLink]="content.logoLink"
            [altlogoText]="content.altlogoText"
            [wide]="true"
            [videoAccountId]="content.video?.accountId"
            [videoId]="content.video?.videoId"
            [videoPlayerId]="content.video?.videoPlayerId"
            [videoTranscript]="content.video?.videoTranscript"
            [caveatContent]="disclaimerCaveat"
            [hasRibbon]="ribbon"
          >
            <div>
              <!-- CTA Buttons -->
              <ng-container *ngIf="content.button?.length">
                <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
              </ng-container>
              <!-- / CTA Buttons -->

              <!-- Important information link -->
              <ng-container
                *ngIf="content.importantinformationlink?.displayText"
              >
                <div edsPadding edsPaddingTop="lg">
                  <eds-link-item
                    [theme]="'light'"
                    [href]="content.importantinformationlink?.url"
                    [title]="content.importantinformationlink?.displayText"
                    [isNewWindow]="content.importantinformationlink?.target"
                    [isExternal]="content.importantinformationlink?.external"
                    [externalSuffix]="
                      content.importantinformationlink?.externalSuffix
                    "
                    (click)="
                      processLink($event, content.importantinformationlink)
                    "
                    [analyticsNoEvent]="true"
                    [signInRequired]="
                      signInRequired | ftIsSignInRequired | async
                    "
                    [hideLockIcon]="hideLockIcon"
                    [signInTooltip]="'common.locked-link-tooltip' | translate"
                  ></eds-link-item>
                </div>
              </ng-container>
              <!-- / Important information link -->
            </div>
          </eds-banner-standard>
        </ng-container>

        <ng-template #EDSColorblockBanner>
          <eds-banner-standard-colorblock
            *ngIf="
              (content?.logoLink === null || content?.logoLink === undefined) &&
              (content?.video === null || content?.video === undefined)
            "
            [breadcrumbTheme]="'default'"
            [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
            [preTitle]="content.category"
            [title]="content.title"
            [summary]="content.subTitle"
            [wide]="true"
            [caveatContent]="disclaimerCaveat"
            [navCards]="links"
          >
            <div>
              <!-- CTA Buttons -->
              <ng-container *ngIf="content.button?.length">
                <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
              </ng-container>
              <!-- / CTA Buttons -->

              <!-- Important information link -->
              <ng-container
                *ngIf="content.importantinformationlink?.displayText"
              >
                <div edsPadding edsPaddingTop="lg">
                  <eds-link-item
                    [theme]="'light'"
                    [href]="content.importantinformationlink?.url"
                    [title]="content.importantinformationlink?.displayText"
                    [isNewWindow]="content.importantinformationlink?.target"
                    [isExternal]="content.importantinformationlink?.external"
                    [externalSuffix]="
                      content.importantinformationlink?.externalSuffix
                    "
                    (click)="
                      processLink($event, content.importantinformationlink)
                    "
                    [analyticsNoEvent]="true"
                    [signInRequired]="
                      signInRequired | ftIsSignInRequired | async
                    "
                    [hideLockIcon]="hideLockIcon"
                    [signInTooltip]="'common.locked-link-tooltip' | translate"
                    [widenParams]="importantinformationlinkWidenParams"
                  ></eds-link-item>
                </div>
              </ng-container>
              <!-- / Important information link -->
            </div>
          </eds-banner-standard-colorblock>
        </ng-template>
      </ng-template>
    </ng-template>

    <!-- Wayfinder link target for impact banner -->
    <ng-container [ngSwitch]="componentLabel">
      <span *ngSwitchCase="'Banner Impact'" id="wayfinder"></span>
    </ng-container>
  </div>
  <!-- CTA Button template -->
  <ng-template #ctaButton>
    <ng-container *ngIf="content.button.length">
      <div edsFlexbox alignItems="center" flexWrap="wrap">
        <ng-container *ngFor="let button of content.button">
          <div>
            <ng-container *ngIf="button.buttonStyle !== 'link'">
              <!-- button -->
              <a
                [edsButton]="button.buttonStyle"
                [title]="button.linkCompound.title"
                [ngClass]="button.linkCompound?.externalLink"
                [href]="button.linkCompound.url"
                [target]="button.linkCompound.target"
                (click)="processLink($event, button.linkCompound)"
                [attr.data-signin-required]="button.signInRequired"
                [attr.data-doc-id]="button.dataDocId"
                [attr.data-title]="button?.dataTitle"
                [attr.rel]="button?.noindex ? 'noindex nofollow' : null"
                [attr.data-document-title]="button.dataTitle"
                [attr.data-external-id]="button.externalId"
                data-analytics-no-event="true"
              >
                <span class="ft__btn__txt">{{
                  button.linkCompound.displayText
                }}</span>
                <eds-icon
                  *ngIf="
                    button?.signInRequired && !button?.hideLockIcon
                      | ftIsSignInRequired
                      | async
                  "
                  edsPadding
                  edsPaddingLeft="xs"
                  edsTooltip
                  tooltipType="medium"
                  [tooltipContent]="'common.locked-link-tooltip' | translate"
                  tooltipPositionDefault="top"
                  tooltipBehavior="fixed"
                  size="small"
                  type="lock"
                ></eds-icon>
              </a>
            </ng-container>
            <ng-container *ngIf="button.buttonStyle === 'link'">
              <!-- link -->
              <!-- TODO: Add 'no index' parameters when EDS changes will be ready -->
              <eds-link-item
                [theme]="'light'"
                [href]="button.linkCompound.url"
                [title]="button.linkCompound.displayText"
                [isNewWindow]="button.linkCompound.target"
                [isExternal]="button.linkCompound?.externalLink"
                [externalSuffix]="button.linkCompound?.externalSuffix"
                (click)="processLink($event, button.linkCompound)"
                [attr.data-signin-required]="button.signInRequired"
                [analyticsNoEvent]="true"
                [signInRequired]="signInRequired | ftIsSignInRequired | async"
                [hideLockIcon]="hideLockIcon"
                [signInTooltip]="'common.locked-link-tooltip' | translate"
                [attr.data-document-title]="button.dataTitle"
                [attr.data-external-id]="button.externalId"
                [widenParams]="button"
              ></eds-link-item>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <!-- No Document -->
  <div *ngIf="!content && isEditMode" class="no-document">
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>{{ componentLabel }}</strong>
      </div>
    </div>
  </div>
</div>
